export const PLACEHOLDER_FILLED_AT_EXECUTION_TIME = '[filled at execution time]';
export const IN_PROGRESS_EXECUTION_ID = '__IN_PROGRESS__';
